import React, { FC } from 'react';
import { motion } from 'framer-motion'

interface ButtonComponentProps {
    name?: string,
    label?: string,
    disabled?: any,
    onClick?: VoidFunction,
    inputStyles?: any,
    iconPath?: string,
    iconClassName?: string,
    className?: string,
    loading?: boolean,
    labelClassname?: string,
    animate?: boolean
}

// Animation variants for the button
const buttonVariants = {
    initial: { 
        scale: 1,
        boxShadow: "0px 0px 0px rgba(0,0,0,0.1)"
    },
    hover: { 
        scale: 1.05,
        boxShadow: "0px 5px 10px rgba(0,0,0,0.15)"
    },
    tap: { 
        scale: 0.95 
    }
};

// Animation variants for the icon
const iconVariants = {
    initial: { x: 0 },
    hover: { 
        x: [0, 10, 0],
        transition: {
            repeat: Infinity,
            repeatType: "loop" as const,
            duration: 1.5
        }
    }
};

const ButtonComponent: FC<ButtonComponentProps> = ({ 
    name, 
    label, 
    disabled, 
    onClick, 
    inputStyles, 
    iconPath, 
    iconClassName, 
    className, 
    loading, 
    labelClassname,
    animate = true,
    ...rest 
}) => {
    return (
        <motion.button
            name={name}
            disabled={disabled || loading}
            onClick={onClick}
            className={`${className ? className : 'flex items-center font-medium justify-center gap-2 rounded-xl bg-yellow text-black p-3 text-sm font-medium relative'}`}
            style={inputStyles}
            variants={animate ? buttonVariants : undefined}
            initial="initial"
            whileHover="hover"
            whileTap="tap"
            transition={{ 
                type: "spring", 
                stiffness: 500, 
                damping: 20
            }}
            {...rest}
        >
            <>
                <p className={labelClassname || ""}>
                    {label}
                </p>
                {iconPath && (
                    <motion.img
                        variants={animate ? iconVariants : undefined}
                        initial="initial"
                        whileHover="hover" 
                        className={iconClassName} 
                        src={iconPath} 
                    />
                )}
            </>
        </motion.button>
    );
};

export default ButtonComponent;
